import './MetaInfo.scss';

interface MetaInfoProps {
  createdAt: string;
  expiresAt: string;
  viewCount: number;
}

function formatDate(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

function getExpirationLabel(expiresAt: string): string {
  const now = new Date();
  const expires = new Date(expiresAt);
  const diffMs = expires.getTime() - now.getTime();

  if (diffMs <= 0) return 'Expired';

  const diffMinutes = Math.floor(diffMs / 60_000);
  const diffHours = Math.floor(diffMs / 3_600_000);
  const diffDays = Math.floor(diffMs / 86_400_000);

  if (diffMinutes < 60) return `${diffMinutes}m remaining`;
  if (diffHours < 24) return `${diffHours}h remaining`;
  return `${diffDays}d remaining`;
}

export function MetaInfo({ createdAt, expiresAt, viewCount }: MetaInfoProps) {
  const expirationLabel = getExpirationLabel(expiresAt);
  const isExpired = new Date(expiresAt).getTime() <= Date.now();

  return (
    <aside className="meta-info">
      <div className="meta-info__item">
        <span className="meta-info__label">Created</span>
        <span className="meta-info__value">{formatDate(createdAt)}</span>
      </div>
      <div className="meta-info__divider" />
      <div className="meta-info__item">
        <span className="meta-info__label">Expires</span>
        <span className={`meta-info__value ${isExpired ? 'meta-info__value--expired' : ''}`}>
          {formatDate(expiresAt)} ({expirationLabel})
        </span>
      </div>
      <div className="meta-info__divider" />
      <div className="meta-info__item">
        <span className="meta-info__label">Views</span>
        <span className="meta-info__value">{viewCount}</span>
      </div>
    </aside>
  );
}
